export const LogbookRoutes = [
    {
        "url": "/logbook",
        "name": "appLayout.schedule.logbook",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "views": {
            "body": {
                "component": "logbookMain"
            }
        },
        "resolve": {
            prerequisiteServiceCheck: ['$state', 'brandServices', 'TeamScheduleService', async function ($state, brandServices, TeamScheduleService) {
                    const activeBrand = await TeamScheduleService.getActiveBrand();
                    const isLogbookEnabled = await brandServices.check(brandServices.SERVICES.LOGBOOK, activeBrand.id);
                    if (!isLogbookEnabled) {
                        $state.go('appLayout.schedule.main');
                    }
                }],
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/logbook/logbook.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ]
    },
    {
        "url": "/logbook-dashboard",
        "name": "appLayout.schedule.logbook.dashboard",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                component: "logbookDashboard",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    },
    {
        "url": "/events",
        "name": "appLayout.schedule.logbook.logbook-events",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                component: "logbookManageEvents",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    }, {
        "url": "/entries?date",
        "name": "appLayout.schedule.logbook.logbook-entries",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookManageEntries",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    },
    {
        "url": "/manage-tasks",
        "name": "appLayout.schedule.logbook.logbook-tasks",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookManageTasks",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    },
    {
        "url": "/team-tasks?my-tasks&date&view",
        "name": "appLayout.schedule.logbook.logbook-team-tasks",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookTeamTasks",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    },
    {
        "url": "/manage-checklists",
        "name": "appLayout.schedule.logbook.logbook-manage-checklists",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookManageChecklists",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    },
    {
        "url": "/checklists?date&view",
        "name": "appLayout.schedule.logbook.logbook-checklists",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookViewChecklists",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    },
    {
        "url": "/task-details?type&id&duplicate&isTodo",
        "name": "appLayout.schedule.logbook.logbook-task-details",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookTaskChecklistDetailsContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ]
    }
];
//# sourceMappingURL=logbook.routes.js.map